module.exports = __webpack_public_path__ + "static/media/tag.50f8eb03.svg";